module.exports = __webpack_public_path__ + "media/images/features/6/feature-6-item-default-32f12b56f3d315c95b6ed59b11e5645b.png";